import { Outlet, NavLink } from "react-router-dom"
import { Brain, MessageSquare, Shield, Users, Bell, Webhook, Globe, Settings } from "lucide-react"
import { cn } from "@/lib/utils"

const SettingsLayout = () => {
  const navItems = [
    {
      title: "General",
      icon: Settings,
      to: "/settings/general",
    },
    {
      title: "AI",
      icon: Brain,
      to: "/settings/ai",
    },
    {
      title: "Chat Interface",
      icon: MessageSquare,
      to: "/settings/chat",
    },
    {
      title: "Security",
      icon: Shield,
      to: "/settings/security",
    },
    {
      title: "Leads",
      icon: Users,
      to: "/settings/leads",
    },
    {
      title: "Notifications",
      icon: Bell,
      to: "/settings/notifications",
    },
    {
      title: "Webhooks",
      icon: Webhook,
      to: "/settings/webhooks",
    },
    {
      title: "Custom Domains",
      icon: Globe,
      to: "/settings/domains",
    },
  ]

  return (
    <div className="container py-8">
      <h1 className="text-2xl font-bold mb-8">Settings</h1>
      <div className="flex flex-col gap-8 md:flex-row">
        <aside className="w-full md:w-64">
          <nav className="space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.title}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-all hover:bg-accent",
                    isActive ? "bg-accent" : "transparent"
                  )
                }
              >
                <item.icon className="h-4 w-4" />
                {item.title}
              </NavLink>
            ))}
          </nav>
        </aside>
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

export default SettingsLayout